import * as utils from './Utils';
import * as bigCommerceUtils from './BigCommerce';
import * as easyStoreUtils from './EasyStore';
import * as shopifyUtils from './Shopify';
import * as shopwareUtils from './Shopware';


export function fetchProductPrices(products, callback) {
  let platform = utils.getEcommercePlatform();

  if (platform === 'shopify') {
    shopifyUtils.fetchProductPrices(products, callback);
    return;
  }

  if (platform === 'bigcommerce') {
    bigCommerceUtils.fetchProductPrices(products, callback);
    return;
  }

  if (platform === 'shopware') {
    shopwareUtils.fetchProductPrices(products, callback);
    return;
  }

  callback();
}


export function convertProductCurrency(product) {
  let platform = utils.getEcommercePlatform();

  if (platform === 'shopify') {
    shopifyUtils.convertProductCurrency(product);
    return;
  }

  if (platform === 'easystore') {
      try {
        easyStoreUtils.convertProductCurrency(product);
      } catch (error) {
        console.error(error);
      }
    return;
  }
}


export function transformProductPriceOutput(output) {
  let platform = utils.getEcommercePlatform();

  if (platform === 'easystore') {
    return easyStoreUtils.transformProductPriceOutput(output);
  }

  return output;
}




